<template>
  <div class="detail-header">
    <i class="iconfont icon-home"/> {{ detail.productName }}
  </div>
  <div class="detail-main">
    <img class="detail-img" :src="detail.imgUrl" :alt="detail.productName">
    <div class="detail-info">
      <h3 style="line-height: 36px">{{ detail.productName }}</h3>
      <div class="info-item">Product Name: {{ detail.productName }}</div>
      <div class="info-item">Item Code: {{ detail.itemCode }}</div>
      <div class="info-item" v-if="detail.size">Size: {{ detail.size }}</div>
      <div class="info-item" v-if="detail.chipSize">Chip Size: {{ detail.chipSize }}</div>
      <div class="info-item" v-if="detail.colour">Colour: {{ detail.colour }}</div>
      <div class="info-item" v-if="detail.VF">VF(V) typ: {{ detail.VF }}</div>
      <div class="info-item" v-if="detail.insideChipSize">Inside Chip Size: {{ detail.insideChipSize }}</div>
      <div class="info-item" v-if="detail.boardHoleSize">Board Hole Size: {{ detail.boardHoleSize }}</div>
      <div class="info-item" v-if="detail.install">Install: {{ detail.install }}</div>
      <div class="info-item" v-if="detail.luminousIntensity">Luminous Intensity: {{ detail.luminousIntensity }}</div>
      <div class="info-item" v-if="detail.IF">IF (mA): {{ detail.IF }}</div>
      <div class="info-item" v-if="detail.viewingAngle">Viewing Angle: {{ detail.viewingAngle }}</div>
      <div class="info-item" v-if="detail.boardSize">Board Size: {{ detail.boardSize }}</div>
      <div class="info-item" v-if="detail.CRI">CRI: {{ detail.CRI }}</div>
      <div class="info-item" v-if="detail.MCD">MCD: {{ detail.MCD }}</div>
      <div class="info-item" v-if="detail.wavelength">Wavelength(nm): {{ detail.wavelength }}</div>
      <div class="info-item" v-if="detail.storageTemperature">Storage Temperature: {{ detail.storageTemperature }}</div>
      <div class="info-item" v-if="detail.application">Application: {{ detail.application }}</div>
      <div class="info-item" v-if="detail.minimumPackingQuantity">Minimum Packing Quantity: {{ detail.minimumPackingQuantity }}</div>
      <div class="info-item" v-if="detail.chip">Chip: {{ detail.chip }}</div>
      <div class="info-item" v-if="detail.current">Current: {{ detail.current }}</div>
      <div class="info-item" v-if="detail.voltage">Voltage: {{ detail.voltage }}</div>
      <div class="info-item" v-if="detail.luminance">Luminance: {{ detail.luminance }}</div>
      <div class="info-item" v-if="detail.power">Power: {{ detail.power }}</div>
      <div class="info-item" v-if="detail.length">Length: {{ detail.length }}</div>
      <div class="info-item" v-if="detail.LEDChip">LED Chip: {{ detail.LEDChip }}</div>
      <div class="info-item" v-if="detail.LEDQuantity">LED Quantity: {{ detail.LEDQuantity }}</div>
      <div class="info-item" v-if="detail.color">Color: {{ detail.color }}</div>
      <div class="info-item" v-if="detail.DC">DC: {{ detail.DC }}</div>
      <div class="info-item" v-if="detail.PCBThickness">PCB Thickness: {{ detail.PCBThickness }}</div>
      <div class="info-item" v-if="detail.waterproof">Waterproof: {{ detail.waterproof }}</div>
      <div class="info-item" v-if="detail.applicableTVSize">Applicable TV Size : {{ detail.applicableTVSize }}</div>
      <div class="info-item" v-if="detail.material">PCB Material: {{ detail.material }}</div>
      <div class="info-item" v-if="detail.stripSize">Strip Size: {{ detail.stripSize }}</div>
      <div class="info-item" v-if="detail.ledCode">LED Code: {{ detail.ledCode }}</div>
      <div class="info-item" v-if="detail.ledQty">LED Qty: {{ detail.ledQty }}</div>
      <div class="info-item" v-if="detail.completeSet">Complete Set: {{ detail.completeSet }}</div>
      <div class="info-item" v-if="detail.ledVoltage">LED Voltage: {{ detail.ledVoltage }}</div>
      <div class="info-item" v-if="detail.usage">Usage: {{ detail.usage }}</div>
      <div class="info-item" v-if="detail.package">Package: {{ detail.package }}</div>
      <div class="info-item" v-if="detail.warranty">Warranty: {{ detail.warranty }}</div>
      <div class="info-item" v-if="detail.applicableTVModule">Applicable TV Module: {{ detail.applicableTVModule }}</div>
      <div class="info-item" v-if="detail.originalEquipmentManufacturer">Original Equipment Manufacturer: {{ detail.originalEquipmentManufacturer }}</div>
    </div>
  </div>

</template>

<script setup lang="ts">
import {useRoute} from "vue-router";
import {productDetail} from "~/data/data";

const route = useRoute()
const id = route.params.id.split('-')[1]
const detail = productDetail.find(item => item.itemCode === id)

useHead({
  title: 'product detail',
  meta: [{
    name: 'description',
    content: `product details for ${detail?.productName}`
  }]
})
</script>

<style lang="stylus" scoped>
.detail-header
  height 30px
  box-sizing border-box
  border-bottom 1px solid #EEE
  color #1e8bac
  font-size 16px
  display flex
  align-items top

  .icon-home
    margin-right 8px
    color #888

.detail-main
  background #FFF
  margin-top 20px
  display flex
  .detail-img
    width: 450px
    height: 450px
    margin-right 20px
    box-shadow 10px 10px 60px #e3e3e3

  .detail-info
    & > h3
      font-size 28px
      margin-bottom 20px
    .info-item
      text-align left
      line-height 30px
      font-size 16px
      color #666
      font-weight 300
</style>
